<template>
  <div class="select-component">
    <p class="selected">Selected: {{ selected }}</p>
    <div class="container">
      <div class="scroll-div" ref="scrollDiv">
        <p id="a">A lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p id="b">B lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p id="c">C lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p>lorem ipsum</p>
        <p id="d">D lorem ipsum</p>
      </div>

      <div class="select-div">
        <button @click="goto('a')">Goto a</button>
        <button @click="goto('b')">Goto b</button>
        <button @click="goto('c')">Goto c</button>
        <button @click="goto('d')">Goto d</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TestPage",
  props: {},
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    goto(id) {
      this.selected = id;
      let scrollDiv = this.$refs.scrollDiv;
      let el = scrollDiv.querySelector(`#${id}`);

      if (el) {
        let scrollDivRect = scrollDiv.getBoundingClientRect();
        let idRect = el.getBoundingClientRect();

        let y = scrollDivRect.y;
        let y1 = idRect.y;

        let offset = y1 - y;

        scrollDiv.scrollBy({
          top: offset,
          behavior: "smooth",
        });
      }
    },
    onBodyScroll() {},
    onScroll() {},
  },
  mounted() {
    window.addEventListener("scroll", this.onBodyScroll);
    this.$refs.scrollDiv.addEventListener("scroll", this.onScroll);
  },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.onBodyScroll);
  //   this.$refs.scrollDiv.removeEventListener("scroll", this.onScroll);
  // },
};
</script>

<style scoped>
button {
  border: 1px solid;
  padding: 1rem;
  position: relative;
}

.selected {
  padding: 1rem;
  position: relative;
}

.select-component {
  max-width: 60rem;
  margin: 0 auto;

  background: #fafafa;
  outline: 1px solid;
  position: relative;
}

.scroll-div {
  max-height: 20rem;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: row;
}
p {
  margin: 2rem 0;
  padding: 1rem;
  outline: 1px solid #ccc;
  position: relative;
}

.container {
  display: flex;
  flex-flow: row wrap;
  outline: 1px solid;
  width: 50%;
}

.select-div {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>./TestPage.vue
